import {useState} from 'react';

import {RowsPhotoAlbum} from 'react-photo-album';
import 'react-photo-album/rows.css';

import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

// import optional lightbox plugins
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

const PhotoGallery = ({photoDimensions = [], photoUrls}) => {
  const [index, setIndex] = useState(-1);

  const photos = photoUrls.map((url, i) => {
    const {width, height} = photoDimensions[i] || {
      width: 500,
      height: 500,
    };

    return ({
      src: url,
      width,
      height,
    });
  })

  return (
    <>
      <RowsPhotoAlbum photos={photos} targetRowHeight={300} onClick={({ index }) => setIndex(index)} />

      <Lightbox
        slides={photos}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        // enable optional lightbox plugins
        plugins={[/*Fullscreen,*/ Slideshow, Thumbnails, Zoom]}
      />
    </>
  );
}

export default PhotoGallery;